import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./text-field-components.css.ts.vanilla.css-mistica.js";
import "./double-field.css.ts.vanilla.css-mistica.js";
var n = {
    default: "skrulh1 _1y2v1nfb5 _1y2v1nfba _1y2v1nfbs",
    fullWidth: "skrulh2 _1y2v1nfb5 _1y2v1nfba _1y2v1nfbs"
};
export { n as variants };
